import cn from 'classnames';
import styles from './styles.scss';
import { ISplash } from 'models/ISplash';
import { NO_ELEMENT, rm } from 'utils';
import { ReactNode } from 'react';

type AppearanceType = 'medium' | 'small';

interface OwnProps extends ISplash {
  className?: string;
  appearance?: AppearanceType;
  children?: ReactNode;
}

const SplashContainer = ({
  appearance,
  children,
  className
}: Pick<OwnProps, 'appearance' | 'children' | 'className'>) => {
  return (
    <div
      className={cn(
        styles.base,
        {
          [styles.medium]: !appearance || appearance === 'medium',
          [styles.small]: appearance === 'small'
        },
        className
      )}
    >
      {children}
    </div>
  );
};

interface TextProps {
  isValid: unknown;
  children: ReactNode;
  className?: string;
}

const Text = ({ isValid, children, className }: TextProps) => {
  if (!isValid) {
    return NO_ELEMENT;
  }

  return <div className={className}>{children}</div>;
};

const Discount = ({
  splashTextMiddle,
  splashTextTop,
  splashTextBottom
}: Pick<OwnProps, 'splashTextTop' | 'splashTextMiddle' | 'splashTextBottom'>) => {
  const hasNoValues = !splashTextMiddle && !splashTextTop && !splashTextBottom;
  if (hasNoValues) {
    return NO_ELEMENT;
  }

  return (
    <div className={styles.discount}>
      <Text isValid={splashTextTop}>{splashTextTop}</Text>
      <Text className={styles.splashTextMiddle} isValid={splashTextMiddle}>
        {splashTextMiddle}
      </Text>
      <Text isValid={splashTextBottom}>{splashTextBottom}</Text>
    </div>
  );
};

const Splash = ({
  splashTextTop,
  splashTextMiddle,
  splashTextBottom,
  splashTextEnd,
  isCampaign,
  isLowPrice,
  appearance,
  className
}: OwnProps) => {
  const hasValues =
    splashTextTop ||
    splashTextMiddle ||
    splashTextBottom ||
    splashTextEnd ||
    isCampaign ||
    isLowPrice;

  if (!hasValues) {
    return NO_ELEMENT;
  }

  return (
    <SplashContainer appearance={appearance} className={className}>
      <Discount
        splashTextMiddle={splashTextMiddle}
        splashTextTop={splashTextTop}
        splashTextBottom={splashTextBottom}
      />
      <Text isValid={splashTextEnd} className={styles.end}>
        {splashTextEnd}
      </Text>
      <Text isValid={isCampaign} className={styles.campaign}>
        {rm('product_campaign')}
      </Text>
      <Text isValid={isLowPrice} className={styles.campaign}>
        {rm('product_non_campaign')}
      </Text>
    </SplashContainer>
  );
};

export default Splash;
